import { IdentifierDTO } from '@zazume/zzm-base';

import { PaginationOptions } from '#/hooks/api/usePagination';
import {
  MarketInsightsPortfolioParams,
  PublicationMarketInsightDetail,
  PublicationMarketInsightRow
} from '#/models/marketInsights/MarketInsights';

import { doGet, toPaginatedURL } from '../../helpers';

const toFilterQueryString = (params: MarketInsightsPortfolioParams): string => {
  const entries = Object.entries(params).filter(([, value]) => Boolean(value)) as [string, string][];
  if (entries.length === 0) {
    return '';
  }
  return `?${new URLSearchParams(entries).toString()}`;
};

export const marketInsights = {
  getPortfolio:
    (params: MarketInsightsPortfolioParams = {}) =>
    (pagination: PaginationOptions) =>
    () =>
      doGet<PublicationMarketInsightRow[]>(
        toPaginatedURL(`/dashboard/market-insights/publications${toFilterQueryString(params)}`, pagination)
      ),
  getByPublication: (publicationWindowId: IdentifierDTO) => () =>
    doGet<PublicationMarketInsightDetail>(`/dashboard/market-insights/publication/${publicationWindowId}`)
};
